import "../../css/master.css";
import "../../css/app.css";
import "../../css/custom.css";
import { useAtom, atom } from 'jotai';
import MainComponent from "./main_component";
import SideBar from "../../sidebar/sidebar";
import Loader from '../../loader/loader';
import { useLocation } from 'react-router-dom';
import CheckUserInfoAgreement from "../../checkUserInfoAgreement";

const isUploadLoadingAtom = atom(false);
const isFinishLoadingAtom = atom(false);

function FileUpload({ AuthVerify }) {

    const [isUploadLoading, setIsUploadLoading] = useAtom(isUploadLoadingAtom);
    const [isFinishLoading, setIsFinishLoading] = useAtom(isFinishLoadingAtom);
    const location = useLocation();

    if (!location.state) {
        window.location.replace("/inquiry_status");
    }

    const handleUploadLoading = (set) => {

        setIsUploadLoading(set)
    }

    const handleFinishLoading = (set) => {

        setIsFinishLoading(set)
    }

    const UploadLoading = () => {
        return (
            <div id="loading_disp">
                <div className="loader-wrap">
                    <div className="popup">
                        <h2>アップロード中</h2>
                        <div className="loader">
                        </div>
                        <div className="loading_msg">
                            <p>アップロード中は画面を閉じないでください。アップロードが失敗する可能性があります。</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            <AuthVerify />
            <CheckUserInfoAgreement />
            <div>
                {isFinishLoading === true ? <Loader /> : null}
                {isUploadLoading === true ?
                    <UploadLoading /> : null}
                <div className="header-utility">
                    <div className="header-utility-inner">
                        <ul className="header-utility-list sub">
                        </ul>
                    </div>
                </div>
                <main className="site-main">
                    <section className="sct-primary">
                        <div className="ls-row str-column" id="ls-row-3-col-1-row-2">
                            <SideBar />
                            <MainComponent handleUploadLoading={handleUploadLoading} handleFinishLoading={handleFinishLoading} />
                        </div>
                    </section>
                </main>
            </div>
        </>
    );
}


export default FileUpload;